module.exports = __webpack_public_path__ + "static/trailer-b840d7022bdb6c3ddf043ad9a5f5cfca.mp4";